<template>
  <div class="SetDataBox">
    <release :data="data" />
  </div>
</template>

<script>
import release from '@/views/Backend/components/release'
export default {
    components: {
        release // 注册组件
  },
  created(){
    console.log(this.$route.query,'this.$route.query');
  },
  data(){
    return{
      data:this.$route.query
    }
  }
}
</script>

<style scoped>

</style>